"use strict"
const angular = require("angular")

/*@ngInject*/
export function windowResizeDirective($window, $timeout) {
  return {
    link: (scope) => {
      // Get window's dimensions
      scope.getDimensions = () => {
        // Namespacing events with name of directive + event to avoid collisions
        // http://stackoverflow.com/questions/23272169/what-is-the-best-way-to-bind-to-a-global-event-in-a-angularjs-directive

        scope.$broadcast("watchWindowResize::resize", {})
      }

      /* Store the window width */
      let windowWidth = $window.innerWidth
      let windowHeight = $window.innerHeight

      // On window resize...
      angular.element($window).on("resize", () => {
        if (
          $window.innerWidth > windowWidth ||
          $window.innerWidth < windowWidth ||
          $window.innerHeight > windowHeight ||
          $window.innerHeight < windowHeight
        ) {
          // Reset timeout
          $timeout.cancel(scope.resizing)

          // Add a timeout to not call the resizing function every pixel
          scope.resizing = $timeout(() => {
            windowWidth = $window.innerWidth
            windowHeight = $window.innerHeight
            scope.getDimensions()
          }, 500)
        }
      })
    },
  }
}

export default angular.module("makeamapAngularApp.windowresize", []).directive("windowResize", windowResizeDirective)
  .name
